import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
//import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import ThemeDefault from '../../theme-default';
import axios from 'axios';
import urlBase from '../../url-base';
import {
  Button
} from 'reactstrap';
import { Styles } from '../../styles/theme';


class RecoverPassword extends React.Component {

    constructor(props) {
        super(props);
    
        this.state = {
            email: '',
            resetSuccess: false
              
        };

        this.styles = {
            loginContainer: {
                minWidth: 500,
                maxWidth: 400,
                height: 'auto',
                position: 'absolute',
                top: '11%',
                left: 0,
                right: 0,
                margin: 'auto'
              },
              paper: {
                paddingLeft: 20,
                paddingRight: 20,
                paddingTop:70,
                paddingBottom:30,
                overflow: 'auto',
                marginTop: 30, 
                height:390,
              },
              loginBtn: {
                float: 'right',
                marginTop: 90,
              },
              logo: {
                width: 344,
                height:64,
                backgroundImage:  'url(' + require('../../assets/images2/new_layout/logo_dental_plano_odontologico.svg') + ')',
                backgroundSize:'100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                margin: '0px auto 30px auto'
              },
              img_background: {
                width: "100%",
                height:400,
                backgroundSize:'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                margin: '0px auto 0px auto',
                bottom:0,
                position:'absolute',
              },
              h1: {
                textAlign: 'center',
                fontSize: 28,
                fontWeight: 500,
                color: '#d10424',
                marginBottom: 0,
                textTransform: 'uppercase',
              },
              h2: {
                textAlign: 'center',
                fontSize: 22,
                fontWeight: 500,
                color: '#757575',
                marginBottom: 0,
                textTransform: 'uppercase',
              }
         
              
        };
        
        this.errorField = {
            email: ''
          };
      
        this.errorFormat = {
            email: ''
        };

    }

    onChange(e) {
        let state = this.state;
        state[e.target.name] = e.target.value;
    
        if (e.target.type === 'email')
          this.onBlurField(e);
    
        if (e.target.value === '')
          this.errorField[e.target.name] = 'Campo obrigatório';
        else
          this.errorField[e.target.name] = '';
    
        this.setState(state);
      }
    
      // Valida campos de e-mail
    onBlurField(e) {
        // Se o campo for do tipo email
        if (e.target.type === 'email') {
          // Se o conteúdo não for válido
          if (!e.target.validity.valid)
            this.errorFormat.email = 'Formato esperado: email@exemplo.com';
          // Se o conteúdo for válido, retira mensagem de erro
          else
            this.errorFormat.email = '';
        }
    }

    recoverPasswordButton(e){
      e.preventDefault(e);
      document.getElementById('i_sucesso').style.display = 'none';
      document.getElementById('i_sucesso').innerHTML = "";
      document.getElementById('i_error_submit').innerHTML = "";

      let options = {
        email: this.state.email
      };
      axios.post(urlBase.loopBack + 'Accounts/reset', options)
       .then((result) => {  
        if (result.status == 204) { 
          document.getElementById('i_sucesso').innerHTML = 'Acesse seu e-mail e siga as instruções para redefinir sua senha.';
          document.getElementById('i_sucesso').style.display = 'block';
          this.setState({ resetSuccess: true });

  
        } else {
          document.getElementById('i_sucesso').innerHTML = 'Não realizar essa operação. Erro :+ result.status';
          document.getElementById('i_sucesso').style.display = 'block';          
        }


      }).catch(function (erro) {
        if (erro.response.data.error.code == "EMAIL_NOT_FOUND") {
          document.getElementById('i_error_submit').innerHTML = 'E-mail não encontrado!';
          document.getElementById('i_error_submit').style.display = 'block';          
          //alert(erro.response.data.error.message);
        }
        else {
          alert('Erro ao recuperar senha');
        }
        }.bind(this));
      }
    
    render(){
        return(
            <MuiThemeProvider muiTheme={ThemeDefault}>

        <div>
          <div style={this.styles.img_background}>{""}</div>
          <div style={this.styles.loginContainer}>

            <div style={this.styles.logo}>&nbsp;</div>
            <h1 style={this.styles.h1}>Planos Dental Center</h1>
            <h1 style={this.styles.h2}>Plataforma de Vendas</h1>

            <Paper style={this.styles.paper}>
               <p className="texto_informativo_recuperar_senha">Informe seu e-mail para recurerar sua senha</p>
              <form>
              <p id="i_sucesso" style={{color: "rgb(244, 67, 54)", display: "none"}}>
                        Senha resetada, acesse com a senha padrão dos seis primeiros digitos do seu CPF.
                      </p>

                <p
                  id="i_error_submit"
                  style={{color: "rgb(244, 67, 54)", display: "none"}}
                >
                  Dados incorretos. Tente novamente.
                </p>

                <TextField
                  errorText={this.errorFormat.email}
                  hintText="E-mail"
                  floatingLabelText="E-mail"
                  type="email"
                  name="email"
                  value={this.state.email}
                  onChange={this.onChange.bind(this)}
                  onBlur={this.onBlurField.bind(this)}
                  fullWidth={true}
                />
                
                <br/><br/> <br/>

                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '5px' }}>
                  <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                          onClick={this.recoverPasswordButton.bind(this)}
                        >
                        Enviar
                  </Button>                  

                </div>
              </form>
            </Paper>
          </div>
        </div>

      </MuiThemeProvider>
      );
    }

}


export default RecoverPassword;



/** WEBPACK FOOTER **
 ** ./src/components/RecoverPassword/RecoverPassword.js
 **/